module.exports = __webpack_public_path__ + "img/SEMCali.407c2687.png";